import { observer } from "mobx-react-lite";
import React from "react";
import { YStack } from "tamagui";
import { Body } from "../../ui/Body";
import type {
  BusinessPlanModel,
  BusinessStaticUserInfoWithUserUid,
} from "../plan/BusinessPlanModel";

export const BusinessProfileQuestions = observer(
  ({
    userInfo,
    businessPlan,
    center = false,
  }: {
    userInfo: BusinessStaticUserInfoWithUserUid;
    businessPlan: BusinessPlanModel;
    center?: boolean;
  }) => {
    // Render only questions answered
    return (
      <YStack gap="$space.small" alignItems={center ? "center" : undefined}>
        {businessPlan.data.profileQuestions.map((question) => {
          const answer = userInfo.profile?.profileQuestions[question.uid];

          if (!answer) {
            return null;
          }

          return (
            <YStack
              key={question.uid}
              alignItems={center ? "center" : undefined}
            >
              <Body muted>{question.question}</Body>
              <Body>{answer}</Body>
            </YStack>
          );
        })}
      </YStack>
    );
  },
);
